import Slide from '@/mixins/Slide'
import IconArrowCircle from '@/components/IconArrowCircle'
import store from '@/store'

export default
{
    mixins: [
        Slide
    ],

    components: {
        IconArrowCircle
    },

    data()
    {
        return {
            current: 0,
            team: 'management'
        }
    },

    computed:
    {
        content()
        {
            return this.$store.slide12
        },

        fullList()
        {
            const list = []
            Object.keys(this.content)
                .map(teamName => this.content[teamName].forEach((data, id) =>
                {
                    data._team = teamName
                    data._id = id
                    list.push(data)
                }))

            return list
        },

        isFirst()
        {
            return this.current < 1
        },

        isLast()
        {
            return this.current > this.$store.slide12[this.team].length - 2
        }
    },

    methods:
    {
        changeTeam(name)
        {

            this.team = name
            this.current = 0
        },

        select(num)
        {
            this.current = Math.min(Math.max(num, 0), this.$store.slide12[this.team].length)
            store.onSlideScroll.dispatch(0)
        },

        previous()
        {
            if(this.team === 'board')
            {
                this.changeTeam('management')
                return true
            }

            return false
        },

        next()
        {
            if(this.team === 'management')
            {
                this.changeTeam('board')
                return true
            }
        }
    }
}
